module.exports = __webpack_public_path__ + "static/media/lighter-periods-ON.97f7cfbe.png";